import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { InvoiceTemplateRow } from "../invoiceTemplates.types";

export const NameCell = memo(function NameCell({
    row,
}: CellContext<ViewTableFeatures, InvoiceTemplateRow, string>) {
    return <ViewTableCell>{row.original.name}</ViewTableCell>;
});
